import { Injectable } from '@angular/core';

import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class EmpresaconfigService {
    apiEmpresaConfigUrl = '/api/empresaConfig';
    

    constructor(private http: HttpClient) {}

    empresaConfig_list(): Observable<any> {
        const empresa = { idEmpresas: 1 };
        return this.http.post(this.apiEmpresaConfigUrl + '/list', empresa);
    }
}
